import React from 'react'

import { ModalPage } from '@/components/ui/modals/ModalPage.component'
import { ImageResponsive } from '@/components/commons/images/ImageResponsive.component'
import { Title } from '@/components/commons/typography/Title'
import { Text } from '@/components/commons/typography/Text'
import { ConnectionButtonsContainer } from '../provisional/no-social-connected/socialConnections/ConnectionButtonsContaienr'
import { Alert } from '@mantine/core'
import { Icon } from '@/public/assets/v2/images/icons'
import Link from 'next/link'

interface ModalConnectionsProps {
  onClose: () => void
  show: boolean
}

export const ModalConnections: React.FC<ModalConnectionsProps> = ({
  onClose,
  show,
}) => {
  return (
    <ModalPage show={show} onClose={onClose} className={['p-8']}>
      <div
        className="bg-secondary rounded-30 full-w flex flex-column items-center py-40 px-20 px-30--tablet pb-20--tablet pt-40--tablet"
        style={{ maxHeight: '70vh' }}
      >
        <Title
          sizeClass="text-20--tablet text-18"
          weightClass="font-bold"
          className="text-left full-w"
        >
          Level up your profile with Analytics!
        </Title>
        <Text
          className="mt-10 text-left full-w"
          sizeClass="text-14--tablet text-12"
        >
          Connect your TikTok, Instagram, or YouTube accounts to start tracking
          and showcasing your social stats! We recommend doing this to help you
          get discovered by other members and brands.
        </Text>

        <div className="full-w my-20">
          <ImageResponsive
            src="/assets/v2/images/analytics/notification-analytics.png"
            alt="analytics notification image"
          />
        </div>

        {/* TODO: joxxe create new social connections buttons when analytics refactor is happening */}
        <div className="pb-40--tablet pb-20">
          <Alert
            className="full-w mb-20"
            color="yellow"
            variant="light"
            icon={<Icon.InfoCircle />}
            title="Just so you know..."
          >
            <span className="text-10 text-12--tablet">
              We <span className="font-bold italic">do not</span> store your
              social credentials. We only import and store your social stats so
              you can showcase them on your profile or{' '}
              <Link href="/checkout" className="text-underline">
                track them privately
              </Link>
              . You can disconnect your social accounts at any time to remove
              your stats.
            </span>
          </Alert>
          <ConnectionButtonsContainer />
        </div>
      </div>
    </ModalPage>
  )
}
